module.exports = __webpack_public_path__ + "static/media/resent-password.24611b32.svg";